import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Condition from '../../../../01_atoms/FormElements/Condition';
import DonationDirectDebit from '../../../../02_molecules/DirectDebitForm';
import DonationCreditCardStripe from './DonationCreditCardStripe';
import DonationRevolutStripe from './DonationRevolutStripe';
import { required } from '../../../../../utils/formFieldValidators';
import { ToggleGroupField } from '../../../../01_atoms/FormElements';
import FormattedText from '../../../../01_atoms/FormattedText';
import { useForm, useFormState } from 'react-final-form';

const PaymentsStep = ({ heading = '', text = '', paymentMethods }) => {
  const formState = useFormState();
  const form = useForm();

  // Clear the form errors when a user selects another payment method
  // only if the form already was submitted, but not successfully.
  useEffect(() => {
    if (formState.submitFailed) {
      form.reset(formState.values);
    }
  }, [formState.values.payment_method]);

  return (
    <div className="donation-form-payment">
      <h2>{heading}</h2>
      {text && <FormattedText text={text} />}
      {paymentMethods.length > 1 && (
        <ToggleGroupField
          name="payment_method"
          validate={required()}
          isRequired
          items={paymentMethods}
          displayMode="icons"
        />
      )}
      <Condition when="payment_method" is="direct_debit_test|direct_debit_live">
        <DonationDirectDebit />
      </Condition>
      <Condition when="payment_method" is="paypal_test|paypal_live|paypal_rg_live|paypal_rg_test">
        <p>
          When you click the PayPal button you will be required to sign into your PayPal account to
          complete the transaction. On completion, you will be returned to the Concern website.
        </p>

        {/* SURPRISE! No PayPal button! It is rendered in DonationFormFooter. */}
      </Condition>
      <Condition
        when="payment_method"
        is="decoupled_stripe_credit_card_live|decoupled_stripe_credit_card_test|decoupled_stripe_credit_card_rg_live|decoupled_stripe_credit_card_rg_test"
      >
        <DonationCreditCardStripe />
      </Condition>
      <Condition
        when="payment_method"
        is="decoupled_stripe_revolut_live|decoupled_stripe_revolut_test|decoupled_stripe_revolut_rg_live|decoupled_stripe_revolut_rg_test"
      >
        <DonationRevolutStripe />
      </Condition>
    </div>
  );
};

PaymentsStep.propTypes = {
  heading: PropTypes.string,
  text: PropTypes.string,
  paymentMethods: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ).isRequired,
};

export default PaymentsStep;
